module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABaUExURUdwTAR1+QdV/wZV/wZV/wSH9QVv+wdW/wdW/wdV/wBX/wdW/wDJ5gdV/wHJ5gZU/wVW/wdW/wVV/wDJ5gZW/wdV/wdV/wZW/wHI5gDJ5wDJ5gR49wdW/wHJ5lusnmQAAAAcdFJOUwAp4m70yxXBf5kHIuLYpzkwk1pQY86zncSAyrn3eMhLAAAAoklEQVQoz7XT2Q7CIBAFULYCsrTYuov//5viME20DA8mep96c9qETgbG1tioDGd0ZH7FkebAsiVRVzRfoJMGUlHB8ykh7jMVVEUiHoy0vPsrCqH6WDLFBocQLguOp/l4eJQsnUkA3irOJIaKZxJHsJQpDJx57237M/dxvOqfjM96N5kOztAiiaI2vhl8bUf28a58X+YNCo01SVtyWC8FFFz8Jy1aMvnvjNUIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/allProduct/div5.png
// module id = L6GL
// module chunks = 0